import { Box, Grid } from "@mui/material";
import SoftBox from "components/SoftComponents/SoftBox";
import SoftButton from "components/SoftComponents/SoftButton";
import SoftInput from "components/SoftComponents/SoftInput";
import SoftTypography from "components/SoftComponents/SoftTypography";
import { useRef, useState } from "react";
import { useFieldArray } from "react-hook-form";

const MultipleImageUpload = ({ field, values, setFieldValue, deviceIndex }) => {

    const inputRef = useRef(null);

    const handleImageChange = async (e) => {
        const files = Array.from(e.target.files);

        const filePromises = files.map((file) => {
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsArrayBuffer(file);

                reader.onload = (event) => {
                    resolve({
                        file,
                        data: event.target.result,
                        previewUrl: URL.createObjectURL(file),
                    });
                };
            });
        });

        const newFiles = await Promise.all(filePromises);

        setFieldValue(field.name, [...values, ...newFiles]);
        e.target.value = "";

        //viewing later on - new Blob([imageArrayBuffer], { type: 'image/jpeg' });
    };

    const handleDelete = (indexToDelete) => {
        const updatedImages = values.filter((_, index) => index !== indexToDelete);
        setFieldValue(field.name, updatedImages);
    };

    return (

        <SoftBox borderRadius="10px" color={"white"} width="100%"
            sx={({ palette: { white }, functions: { rgba } }) => ({ backgroundColor: rgba("#eeeeee", 1) })}
        >
            <SoftBox>
                <input type="file" ref={inputRef} accept="image/*" multiple onChange={handleImageChange} hidden />
                <Box display="flex" flex={1} flexDirection={{ xxs: "column", md: "row" }}>
                    <Box flex={{ xxs: 12 }} pb={1}>
                        <SoftButton color="secondary" variant="gradient" size="small" sx={{ fontSize: '13px', boxShadow: 0, borderRadius: "10px 10px 0 0", width: '100% !important' }} onClick={() => inputRef.current.click()}>Upload images</SoftButton>
                    </Box>
                </Box>
            </SoftBox>
            <Box p={5}>
                <Grid container spacing={1}>
                    {values.length ? (
                        <>
                            {values.map((image, index) => (
                                <Grid item xxs={6} lg={4} x3l={2} key={index}>
                                    <SoftBox display="flex" flexDirection="column">
                                        <SoftBox component={'img'} src={image.previewUrl} alt={`preview ${index}`} mb={1} style={{ border: '1px solid black', objectFit: 'contain' }} />
                                        <SoftButton size="small" color="error" onClick={() => handleDelete(index)}>
                                            Delete
                                        </SoftButton>
                                    </SoftBox>
                                </Grid>
                            ))}
                        </>
                    ) : (
                        <Grid item xxs={12}>
                            <SoftBox display="flex" flexDirection="row" justifyContent="center" alignItems="center">
                                <SoftTypography variant='button' color="secondary">
                                    No images to show
                                </SoftTypography>
                            </SoftBox>
                        </Grid>
                    )}
                </Grid>
            </Box>
        </SoftBox>
    );
};

export default MultipleImageUpload;